// src/components/common/Loader.jsx
import React from 'react';
import LoadingGif from '../../assets/images/loading.gif';

const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div className="w-16 h-16 rounded-full overflow-hidden">
        <img 
          src={LoadingGif} 
          alt="Loading..." 
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

// Alternative spinner version without using an image
const SpinnerLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-primary border-solid"></div>
    </div>
  );
};

export default Loader;
export { SpinnerLoader };